import { render, staticRenderFns } from "./ClientEditor.vue?vue&type=template&id=57e02416&scoped=true&"
import script from "./ClientEditor.vue?vue&type=script&lang=js&"
export * from "./ClientEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e02416",
  null
  
)

export default component.exports